import { useLocation, Navigate, Link as RouterLink, useNavigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography, Divider, IconButton, Tooltip, Button, Box, FormControl, FormLabel, TextField } from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';

// components
import { Icon } from '@iconify/react';
import Page from '../../../components/Page';
import Scrollbar from "../../../components/Scrollbar";
import AppCache from '../../../services/AppCache';
// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1)
}));
export default function ContactMasterDetailsPage({ contactData, Column, pageSize, setPageSize, addNew, handleAddContact, handleAddNewClose, contactName, contactNo, email, designation, mobile, location, handleContactName, handleContactNo, handleEmail, handleDesignation, handleMobile, handleLocation, handleResetContact, handleContactSave, mode, isContactSaving }) {
    const CurrentClientContact = AppCache.GetClientInstallationLocations();


    console.log("CurrentClientContact", CurrentClientContact);
    const navigate = useNavigate();
    const locationNav = useLocation()
    const { contactmaster } = locationNav.state;
    const { cliInstallation } = locationNav.state;
    console.log("contactmaster", contactmaster);
    console.log("cliInstallation", cliInstallation);
    const handelNav = () => {

        navigate('/dashboard/clientinstallationdetailspage', {
            replace: true,
            state: {

                cliInstallation: CurrentClientContact

            }
        });
    }

    return (
        <Page title="  Contact Details Details | tiketic" >

            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>

                <Card

                    sx={{

                        height: "435px",
                        display: "flex",
                        flexDirection: "column",
                        width: '100%',

                        mt: 1,
                        borderRadius: addNew ? "0px" : "0 16px 0 0",
                    }}
                >
                    {mode !== "view" && addNew && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, mr: 2 }}>
                            <Tooltip title="Add New Contact">
                                <Button
                                    sx={{ color: 'white' }}
                                    onClick={handleAddContact}
                                    size="small"
                                    variant="contained"
                                    color="primary">
                                    <Icon icon="ic:baseline-plus" width="25px" height="25px" />
                                    Add New
                                </Button>
                            </Tooltip>
                        </Box>
                    )}
                    <DataGrid
                        rows={contactData}
                        columns={Column}
                        density="compact"
                        getRowId={(row) => row.id || contactData.indexOf(row)}
                        components={{ Toolbar: GridToolbar }}
                        pagination
                        paginationMode="client"
                        rowsPerPageOptions={[25, 50, 100]}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        sx={{ border: "#FFFFFF", px: 2 }}
                    />
                </Card>

                {!addNew && (

                    <Card

                        sx={{
                            p: 0,
                            height: "435px",
                            mt: 1,
                            display: "flex",
                            flexDirection: "column",
                            width: '332px',
                            mr: 2,
                            borderRadius: "16px 16px 0 0",

                        }}
                    >

                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 16px',
                                borderBottom: '1px solid #E5E5E5',
                                backgroundColor: '#fff',
                                m: 0, // remove outer margins
                            }}
                        >
                            <Typography variant="h5" fontWeight='600'>
                                Add New
                            </Typography>

                            <IconButton
                                onClick={handleAddNewClose}
                                sx={{
                                    color: '#70747A',

                                }}

                            >
                                <CloseIcon sx={{ fontSize: 20 }} />
                            </IconButton>
                        </Box>
                        <Box sx={{ flex: 1, overflowY: 'auto', px: 2, py: 1 }}>
                            <Stack spacing={1}>
                                <FormControl size="small" fullWidth>
                                    <FormLabel >Contact Person Name</FormLabel>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={contactName}
                                        onChange={handleContactName}
                                        placeholder="Enter Person Name"

                                    />
                                </FormControl>
                                <FormControl size="small" fullWidth>
                                    <FormLabel >Contact Number</FormLabel>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={contactNo}
                                        onChange={handleContactNo}
                                        type="number"
                                        placeholder="Enter Contact Number"

                                    />
                                </FormControl>
                                <FormControl size="small" fullWidth>
                                    <FormLabel >Email Address</FormLabel>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={email}
                                        onChange={handleEmail}
                                        type="email"
                                        placeholder="Enter Email address"

                                    />
                                </FormControl>
                                <FormControl size="small" fullWidth>
                                    <FormLabel >Designation</FormLabel>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={designation}
                                        onChange={handleDesignation}
                                        placeholder="Enter Designation"

                                    />
                                </FormControl>
                                <FormControl size="small" fullWidth>
                                    <FormLabel >Mobile</FormLabel>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={mobile}
                                        onChange={handleMobile}
                                        type="number"
                                        placeholder="Enter Mobile"

                                    />
                                </FormControl>
                                <FormControl size="small" fullWidth>
                                    <FormLabel >Location</FormLabel>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={location}
                                        onChange={handleLocation}
                                        placeholder="Enter Location"

                                    />
                                </FormControl>
                            </Stack>
                        </Box>
                        <Box sx={{ p: 1, borderTop: '1px solid #E5E5E5', }}>
                            <Stack direction="row" spacing={1} justifyContent="center">
                                <Tooltip title="Reset">

                                    <Button variant="outlined" sx={{ width: '90px', color: '#374151' }} onClick={handleResetContact}>Reset</Button>
                                </Tooltip >
                                {/* <Tooltip title="Add another"> */}
                                {/*    <Button variant="contained" sx={{ width: '125px' }} onClick={handleContactAddAnother}>Add another</Button> */}
                                {/* </Tooltip > */}
                                <Tooltip title="Save">
                                    <LoadingButton
                                        size="medium"
                                        type="submit"
                                        variant="contained"
                                        sx={{ color: 'white', width: '90px' }}
                                        loading={isContactSaving}
                                        onClick={handleContactSave}
                                    >
                                        Save
                                    </LoadingButton>
                                </Tooltip >
                            </Stack>
                        </Box>

                    </Card>
                )}
            </Box>
          
        </Page >
    );
}

